import request from '@/utils/request'

// 查询离职申请列表
export function listDepartEnd(query) {
    return request({
        url: '/bpm/departEnd/findAll',
        method: 'post',
        data: query
    })
}
// 查询转正申请详细
export function initApply(departId) {
    return request({
        url: '/bpm/departEnd/initApply?departId='+departId,
        method: 'get'
    })
}

// 修改转正申请
export function completeTask(data) {
    return request({
        url: '/bpm/departEnd/completeTask',
        method: 'post',
        data: data
    })
}
// 查询离职申请详细
export function getDepartEnd(id) {
    return request({
        url: '/bpm/departEnd/findOne?id=' + id,
        method: 'post'
    })
}

export function getByProcessInstanceId(processInstanceId) {
    return request({
        url: '/bpm/departEnd/getByProcessInstanceId?processInstanceId=' + processInstanceId,
        method: 'post'
    })
}

// 新增离职申请
export function addDepartEnd(data) {
    return request({
        url: '/bpm/departEnd/add',
        method: 'post',
        data: data
    })
}

// // 修改离职申请
// export function updateDepartEnd(data) {
//     return request({
//         url: '/bpm/departEnd/edit',
//         method: 'post',
//         data: data
//     })
// }

// 删除离职申请
export function delDepartEnd(id) {
    return request({
        url: '/bpm/departEnd/remove',
        method: 'post',
        data: id
    })
}

// 导出离职申请
export function exportDepartEnd(query) {
    return request({
        url: '/bpm/departEnd/export',
        method: 'post',
        data: query
    })
}
